export default __webpack_public_path__ + "static/media/me-icon-bottom-nav-mobile.a30c4e41.webp";